import {Box, Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

type RouteSummaryProps = TestIdProps & {
  summary: string;
};

/** Distance and duration of the drive, floating over the map like a sports tracker. */
export function RouteSummary(props: RouteSummaryProps) {
  return (
    <Box
      position="absolute"
      top={3}
      left={3}
      paddingVertical={1}
      paddingHorizontal={3}
      borderRadius="circular"
      backgroundColor="palettes.white.10.80"
      boxShadow="elevation_2"
      pointerEvents="none"
      data-testid={suffixTestId('summary', props)}
    >
      <Text size="small" alternative>
        {props.summary}
      </Text>
    </Box>
  );
}
